import React from 'react';
import { tripPlanModel } from '../../data/tripPlanModel';

const TripPlanCard = ({ 
  tripPlan, 
  onEdit, 
  onDelete, 
  onView, 
  onSelect, 
  isSelectable = false,
  isSelected = false,
  showActions = true 
}) => {
  const theme = tripPlanModel.themeOptions.find(t => t.value === tripPlan.tripTheme);
  const status = tripPlanModel.statusOptions.find(s => s.value === tripPlan.status);
  
  const handleCardClick = () => {
    if (isSelectable && onSelect) {
      onSelect(tripPlan);
    } else if (onView) {
      onView(tripPlan);
    }
  };

  return (
    <div 
      className={`bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 ${
        isSelectable ? 'cursor-pointer' : ''
      } ${isSelected ? 'ring-2 ring-blue-500' : ''}`}
      onClick={handleCardClick}
    >
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {tripPlan.tripName}
            </h3>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span>{theme?.icon} {theme?.label}</span>
              <span>•</span>
              <span>{new Date(tripPlan.tripDate).toLocaleDateString('th-TH')}</span>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${status?.color}`}>
              {status?.label}
            </span>
            {tripPlan.isPublic && (
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                🌐 สาธารณะ
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="space-y-3">
          {/* Location */}
          <div className="flex items-start gap-2">
            <span className="text-gray-500 mt-0.5">📍</span>
            <div>
              <span className="text-sm font-medium text-gray-700">สถานที่:</span>
              <p className="text-sm text-gray-600">{tripPlan.tripLocation}</p>
            </div>
          </div>

          {/* Participants */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-gray-500">👥</span>
              <span className="text-sm text-gray-600">
                ผู้เข้าร่วม: {tripPlan.participantCount} คน
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-gray-500">👩</span>
              <span className="text-sm text-gray-600">
                น้องที่ต้องการ: {tripPlan.requiredGirls} คน
              </span>
            </div>
          </div>

          {/* Description */}
          {tripPlan.description && (
            <div className="flex items-start gap-2">
              <span className="text-gray-500 mt-0.5">📝</span>
              <div>
                <span className="text-sm font-medium text-gray-700">รายละเอียด:</span>
                <p className="text-sm text-gray-600 line-clamp-2">
                  {tripPlan.description}
                </p>
              </div>
            </div>
          )}

          {/* Additional Info */}
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <span>สร้างเมื่อ: {new Date(tripPlan.createdAt).toLocaleDateString('th-TH')}</span>
            {tripPlan.bookings && tripPlan.bookings.length > 0 && (
              <span>จองแล้ว: {tripPlan.bookings.length} ครั้ง</span>
            )}
          </div>
        </div>
      </div>

      {/* Actions */}
      {showActions && (
        <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 flex justify-end gap-2">
          {onView && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onView(tripPlan);
              }}
              className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition"
            >
              👁️ ดูรายละเอียด
            </button>
          )}
          {onEdit && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(tripPlan);
              }}
              className="px-3 py-1 text-sm text-green-600 hover:text-green-800 hover:bg-green-50 rounded transition"
            >
              ✏️ แก้ไข
            </button>
          )}
          {onDelete && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(tripPlan);
              }}
              className="px-3 py-1 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition"
            >
              🗑️ ลบ
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default TripPlanCard;









